import { create as t } from "zustand";
import { devtools as l } from "zustand/middleware";
import { produce as i } from "immer";
const d = {
  name: "",
  address: "",
  zip_code: "",
  city: "",
  category: "",
  sub_category: ""
}, s = t()(
  l(
    (r) => ({
      currentPolygonId: null,
      currentPolygonSize: null,
      poiFields: d,
      isLoading: !1,
      isPopupOpen: !1,
      mode: void 0,
      actions: {
        setPlDrawRef: (e) => {
          r(
            i((o) => {
              o.plDrawRef = e;
            })
          );
        },
        setCurrentPolygonId: (e) => {
          r(
            i((o) => {
              o.currentPolygonId = e;
            })
          );
        },
        resetCurrentPolygonId: () => {
          r(
            i((e) => {
              e.currentPolygonId = void 0;
            })
          );
        },
        setCurrentPolygonSize: (e) => {
          r(
            i((o) => {
              o.currentPolygonSize = e;
            })
          );
        },
        resetCurrentPolygonSize: () => {
          r(
            i((e) => {
              e.currentPolygonSize = void 0;
            })
          );
        },
        setField: (e, o) => r(
          i((n) => {
            n.poiFields[e] = o;
          })
        ),
        setIsLoading: (e) => {
          r(
            i((o) => {
              o.isLoading = e;
            })
          );
        },
        resetFields: () => {
          r(
            i((e) => {
              e.poiFields = d;
            })
          );
        },
        setPopupIndication: (e) => {
          r(
            i((o) => {
              o.popupIndication = e;
            })
          );
        },
        setCallbacks: (e) => {
          r(
            i((o) => {
              o.callbacks = e;
            })
          );
        },
        setCreatedPOI: (e) => {
          r(
            i((o) => {
              o.createdPOI = e;
            })
          );
        },
        resetCreatedPOI: () => {
          r(
            i((e) => {
              e.createdPOI = void 0;
            })
          );
        },
        setMode: (e) => {
          r(
            i((o) => {
              o.mode = e;
            })
          );
        },
        resetMode: () => {
          r(
            i((e) => {
              e.mode = void 0;
            })
          );
        },
        setPoiId: (e) => {
          r(
            i((o) => {
              o.poiId = e;
            })
          );
        },
        resetPoiId: () => {
          r(
            i((e) => {
              e.poiId = void 0;
            })
          );
        }
      }
    }),
    {
      name: "CreatePOIToolStore",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__),
      stateSanitizer: (r) => ({
        ...r,
        plDrawRef: "refplaceholder"
      })
    }
  )
);
export {
  s as useCreatePoiStore
};
//# sourceMappingURL=index.es137.js.map
